module.exports = __webpack_public_path__ + "img/luxura_vegaz_crystal_white.1b424160.svg";